exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-15e39032]{width:100%;height:70px;position:fixed;left:0;bottom:0;z-index:10;background-color:#f2f2f2;border-top:1px solid #ccc}.footer ul[data-v-15e39032]{width:100%;height:100%;display:flex}.footer ul li[data-v-15e39032]{flex:1}.footer ul li a[data-v-15e39032]{display:block;width:100%;height:100%;line-height:70px;text-align:center;font-size:3rem;color:#888}.footer ul li a[data-v-15e39032]:hover{color:#3a99d8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15e39032","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/component/Footer.vue
// module id = 37
// module chunks = 0